import actions from "./registrationFormActions";
import {v4 as uuidv4} from 'uuid';
import NameCase from '@compwright/namecase';

const initialState = {
    name: '',
    country: 'CZ',
    email: '',
    phone: '',
    entries: [],
    addDialogOpen: false,
    addDialogMode: actions.ADD_DIALOG_MODE.ADD_NEW,
    addDialogSelectedCategoryId: null,
    addDialogSelectedCategory: null,
    addDialogEntry: null,
    addDialogErrors: [],
    addDialogErrorMessage: null,
    submitDialogOpen: null,
    submitDialogError: null,
    submitDialogStatus: actions.SUBMIT_DIALOG_STATUS.IDLE,
    validation: {formValid: false, errors: {}}
};

function updateContact(initialState, action) {
    let dirty = false;
    const newState = {...initialState};
    if (typeof action.name !== 'undefined') {
        dirty = true;
        newState.name = action.name;
    }
    if (typeof action.country !== 'undefined') {
        dirty = true;
        newState.country = action.country;
    }
    if (typeof action.email !== 'undefined') {
        dirty = true;
        newState.email = action.email;
    }
    if (typeof action.phone !== 'undefined') {
        dirty = true;
        newState.phone = action.phone;
    }
    if (dirty) {
        newState.validation = validateForm(newState);
        return newState;
    } else {
        return initialState;
    }
}

function validateForm(state) {
    const {entries, name, phone, email} = state;
    const nameValid = name && name.trim().length > 0;
    const phoneValid = phone && phone.trim().length > 0;
    const emailValid = email && email.trim().length > 0;

    return {
        formValid: nameValid && phoneValid && emailValid && entries.length > 0,
        errors: {
            email: !emailValid,
            name: !nameValid,
            phone: !phoneValid
        }
    };
}


function createPlayers (category, defaultCountry) {
    // return an array of players based on the category
    const players = [];
    players.push({
        lastName: '',
        firstName: '',
        gender: category.eligibility  === 'WOMEN' ? 'FEMALE' : 'MALE',
        country: defaultCountry ? defaultCountry : 'CZ',
        params: []
    });
    if (category.multiplicity > 1) {
        const gender = category.eligibility === 'WOMEN' || category.eligibility === 'MIXED' ? 'FEMALE' : 'MALE';
        players.push({
            lastName: '',
            firstName: '',
            gender: gender,
            country: defaultCountry ? defaultCountry : 'CZ',
            params: []
        });
    }
    if (category.params && category.params.length > 0) {
        category.params.forEach(p => {
            if (p.granularity === 'PLAYER') {
                players.forEach(player => {
                    // add a parameter for each
                    const param = {
                        type: p.type,
                        name: p.name,
                        boolValue: p.type === 'BOOL' ? false : null,
                        stringValue: p.type === 'STRING' ? '' : null
                    };
                    player.params.push(param);
                });
            }
        });
    }

    return players;
}

function createNewEntry(category, country) {
    return {
        players: createPlayers(category, country),
        eventCategoryId: category.id,
        eventCategoryName: category.name,
        params: [],
        deleted: false,
        tempId: uuidv4()
    };
}

function openAddDialog(state, action) {
    const newState = {...state};
    newState.addDialogOpen = action.open;
    if (action.open) {
        const entry = action.entry ? cloneEntry(action.entry) : createNewEntry(action.category, state.country);
        newState.addDialogEntry = entry;
        if (entry.id) {
            newState.addDialogMode = actions.ADD_DIALOG_MODE.EDIT_EXISTING;
        } else {
            if (entry.players && (entry.players.length >= 1) && entry.players[0].firstName) {
                newState.addDialogMode = actions.ADD_DIALOG_MODE.EDIT_NEW;
            } else {
                newState.addDialogMode = actions.ADD_DIALOG_MODE.ADD_NEW;
            }
        }

        newState.addDialogSelectedCategory = action.category;
        newState.addDialogSelectedCategoryId = action.category.id;
    }
    return newState;
}

function addDialogSelectCategory(state, action) {
    const entry = {...state.addDialogEntry};
    entry.players = createPlayers(action.category, state.country);
    entry.eventCategoryId = action.category.id;
    entry.eventCategoryName = action.category.name;
    return {
        ...state,
        addDialogSelectedCategory: action.category,
        addDialogSelectedCategoryId: action.category.id,
        addDialogEntry: entry
    };
}

function addDialogUpdatePlayer(state, action) {
    const entry = cloneEntry(state.addDialogEntry);
    const player = entry.players[action.playerIndex];
    player[action.propertyName] = action.value;
    return {
        ...state,
        addDialogEntry: entry
    };
}

function addDialogFixPlayerNameCase(state, action) {
    if (action.propertyName !== 'firstName' && action.propertyName !== 'lastName') {
        // we don't "fix" any fields other than firstName or lastName
        return state;
    }
    const entry = cloneEntry(state.addDialogEntry);
    const player = entry.players[action.playerIndex];
    player[action.propertyName] = NameCase(player[action.propertyName]);
    return {
        ...state,
        addDialogEntry: entry
    };
}

function addDialogUpdatePlayerParam(state, action) {
    const entry = cloneEntry(state.addDialogEntry);
    const player = entry.players[action.playerIndex];

    let param = player.params.find(p => action.paramName === p.name);
    if (param) {
        if (param.type === 'BOOL') {
            param.boolValue = action.value;
        } else {
            param.stringValue = action.value;
        }
    } else {
        console.log("Hmm... can't set a parameter that doesn't exist")
    }
    return {
        ...state,
        addDialogEntry: entry
    };
}


function findEntry(entries, tgtEntry) {
    let entry = entries.find(e => e.id && e.id === tgtEntry.id);
    if (entry) {
        return entry;
    }
    entry = entries.find(e => e.tempId && e.tempId === tgtEntry.tempId);
    return entry;
}


function addOrSaveEntry(state, action) {
    const newState = {...state};
    const existingEntry = findEntry(state.entries, action.entry);
    let entries = [];
    if (existingEntry) {
        entries = state.entries.map(e => {
            if (e.id === existingEntry.id || e.tempId === existingEntry.tempId) {
                return action.entry;
            } else {
                return e;
            }
        });
        newState.addDialogOpen = false;
    } else {
        entries = state.entries.slice();
        entries.push(action.entry);
        newState.addDialogEntry = createNewEntry(state.addDialogSelectedCategory, state.country);
    }
    newState.entries = entries;
    newState.validation = validateForm(newState);
    return newState;
}

function cloneEntry(entry) {
    const newEntry = {...entry};
    if (entry.params) {
        newEntry.params = entry.params.map(p => {
            return {...p};
        });
    }
    if (entry.players) {
        newEntry.players = entry.players.map(p => {
            return {
                ...p,
                params: p.params.map(pp => {
                    return {...pp};
                })
            };
        });
    }
    return newEntry;
}

function undeleteEntry(state, action) {
    const entry = state.entries.find(e => action.id === e.id);
    if (!entry) {
        return state;
    }

    const newEntry = cloneEntry(entry);
    newEntry.deleted = false;
    const newEntries = state.entries.map(e => e.id === newEntry.id ? newEntry : e);
    return {
        ...state,
        entries: newEntries
    };
}

function deleteEntry(state, action) {
    const entry = state.entries.find(e => action.id === e.tempId || action.id === e.id);
    if (!entry) {
        return state;
    }

    const newEntry = cloneEntry(entry);
    newEntry.deleted = !newEntry.deleted;
    const newEntries = state.entries.map(e => ((e.id && e.id === newEntry.id) || (e.tempId === newEntry.tempId)) ? newEntry : e);

    return {
        ...state,
        entries: newEntries
    };
}


function submitRegistrationSuccess(state, action) {
    const newState = {
        ...state,
        submitDialogStatus: actions.SUBMIT_DIALOG_STATUS.SUCCESS,
        name: '',
        email: '',
        phone: '',
        entries: []
    };
    return newState;
}


function registrationFormReducer(state = initialState, action) {

    switch (action.type) {
        case actions.SET_REGFORM_CONTACT:
            return updateContact(state, action);
        case actions.ADD_OR_SAVE_ENTRY:
            return addOrSaveEntry(state, action);
        case actions.DELETE_ENTRY:
            return deleteEntry(state, action);
        case actions.UNDELETE_ENTRY:
            return undeleteEntry(state, action);
        case actions.ADD_DIALOG_OPEN:
            return openAddDialog(state, action);
        case actions.ADD_DIALOG_SELECT_CATEGORY:
            return addDialogSelectCategory(state, action);
        case actions.ADD_DIALOG_UPDATE_PLAYER:
            return addDialogUpdatePlayer(state, action);
        case actions.ADD_DIALOG_UPDATE_PLAYER_PARAM:
            return addDialogUpdatePlayerParam(state, action);
        case actions.ADD_DIALOG_FIX_NAME_CASE:
            return addDialogFixPlayerNameCase(state, action);
        case actions.SUBMIT_REGISTRATION_STARTED:
            return {...state, submitDialogStatus: actions.SUBMIT_DIALOG_STATUS.IN_PROGRESS};
        case actions.SUBMIT_REGISTRATION_SUCCESS:
            return submitRegistrationSuccess(state, action);
        case actions.SUBMIT_REGISTRATION_ERROR:
            return {...state, submitDialogError: action.err.message, submitDialogStatus: actions.SUBMIT_DIALOG_STATUS.ERROR};
        case actions.SUBMIT_REGISTRATION_DIALOG_CLOSE:
            return {...state, submitDialogStatus: actions.SUBMIT_DIALOG_STATUS.IDLE};
        default:
            break;
    }
    return state;
}

export default registrationFormReducer;